<template>
    <div class="article-swiper__container">
        <div class="wrapper">
            <div class="row overflow-hidden">
                <div class="swiper-outer-container">
                    <div class="swiper-container" ref="articleSwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide d-flex" v-for="entry in slides">
                                <div class="col-lg-6">
                                    <div class="article-swiper__img-wrapper">
                                        <img :src="entry.img" :alt="entry.headline" :title="entry.headline">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="content">
                                        <span class="h3 white article-swiper__headline">{{ entry.headline }}</span>
                                        <p class="article-swiper__text">{{ entry.text }}</p>
<!--                                        <a v-if="typeof entry.btntext === 'undefined'" :href="entry.url" class="btn">{{ entry.name }}</a>-->
                                        <a :href="entry.url" class="btn btn-primary">{{ entry.btntext }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="article-swiper__pagination-wrapper">
                <div class="swiper-pagination article-swiper__pagination-wrapper" ref="pagination"></div>
            </div>
            <div class="swiper-button-prev" ref="prev">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
                    <path fill="#FFF" d="M8.45833178,0.292893219 L9.87254534,1.70710678 L2.414,9.165 L9.87254534,16.6237703 L8.45833178,18.0379839 L0.292893219,9.87254534 C-0.0675907428,9.51206138 -0.0953202783,8.94483033 0.209704612,8.55253912 L0.292893219,8.45833178 L8.45833178,0.292893219 Z"/>
                </svg>
            </div>
            <div class="swiper-button-next" ref="next">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
                    <path fill="#FFF" d="M8.45833178,0.292893219 L9.87254534,1.70710678 L2.414,9.165 L9.87254534,16.6237703 L8.45833178,18.0379839 L0.292893219,9.87254534 C-0.0675907428,9.51206138 -0.0953202783,8.94483033 0.209704612,8.55253912 L0.292893219,8.45833178 L8.45833178,0.292893219 Z"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";

    export default {
        data(){
          return{
              swiperInstance: null,
              slides: []
          }
        },
        props: {
            listEntries: Array,
            mainHeadline: String,
        },

        mounted(){
            this.initSlides();
            this.initSwiper();
        },

        methods: {

            initSlides(){
                this.slides = this.listEntries.map(entry => {
                    let slide = {};
                    // check if entry has itemData
                    if (typeof entry.itemData != 'undefined'){
                        // only add item data when text, img or headline aren't already set.
                        if (!slide.img) slide.img = entry.itemData.images.all[0].url;
                        if (!slide.headline) slide.headline = entry.itemData.texts.name1;
                        if (!slide.text) slide.text = entry.itemData.texts.shortDescription;
                    }
                    if (typeof entry.btntext === "undefined" || !entry.btntext) {
                        slide.btntext = 'Zum Produkt'
                    }
                    return  {...slide, ...entry};
                })
            },


            initSwiper(){
                this.$nextTick(()=> {
                    let swiperRef = this.$refs.articleSwiper;
                    this.swiperInstance = new Swiper(swiperRef, {
                        navigation: {
                            nextEl: this.$refs.next,
                            prevEl: this.$refs.prev,
                        },
                        pagination: {
                            el: this.$refs.pagination,
                            type: 'bullets',
                        },
                        slidesPerView: 1,

                        loop: false,
                    });
                });
            },
        }

    }
</script>
